/** a[x,y,z] */
export interface IAcceleration {
  /** acceleration x */
  ax: number;
  /** acceleration y */
  ay: number;
  /** acceleration z */
  az: number;
}

/** q[w,x,y,z] */
export interface IOrientation {
  /** orientation w */
  qw: number;
  /** orientation x */
  qx: number;
  /** orientation y */
  qy: number;
  /** orientation z */
  qz: number;
}

export interface IAziAltCoordinate {
  /** i.e. yaw */
  azimuth_rad: number;

  /** i.e. tilt */
  altitude_rad: number;
}

export interface ISeamOrientation {
  // aka: altitude
  latitude_deg: number;
  // aka: azimuth
  longitude_deg: number;
}

export const DEFAULT_SEAMS: ISeamOrientation = {
  latitude_deg: 0,
  longitude_deg: 0,
};

// describes a point on the face of a sphere
export interface ISurfacePoint {
  x: number;
  y: number;
  z: number;
}

export interface IReleasePosition {
  px: number;
  pz: number;
}

/** p[x,y,z] */
export interface IPosition {
  /** position x in feet, +ve => LHP, otherwise RHP */
  px: number;
  /** position y in feet, i.e. distance to plate */
  py: number;
  /** position z in feet, i.e. distance from ground */
  pz: number;
}

/** w[x,y,z] */
export interface ISpin {
  /** spin x, i.e. back spin */
  wx: number;
  /** spin y, i.e. gyro spin */
  wy: number;
  /** spin z, i.e. side spin */
  wz: number;
}

export interface ISpinExt {
  /** net spin */
  wnet: number;

  /** gyro angle, degrees */
  gyro_angle: number;

  /** spin axis, degrees */
  waxis: number;
}

/** v[x,y,z] */
export interface IVelocity {
  /** velocity x */
  vx: number;
  /** velocity y */
  vy: number;
  /** velocity z */
  vz: number;
}

/** a[1,2,3] */
export interface IWheelAngle {
  /** wheel angle 1 */
  a1: number;
  /** wheel angle 2 */
  a2: number;
  /** wheel angle 3 */
  a3: number;
}

/** w[1,2,3] */
export interface IWheelSpeed {
  /** wheel speed 1 */
  w1: number;
  /** wheel speed 2 */
  w2: number;
  /** wheel speed 3 */
  w3: number;
}
